(() => {
  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-mvl]').forEach(root => {
      if (root.dataset.mvlReady) return;
      root.dataset.mvlReady = 'true';
      const demos = root.querySelectorAll('[data-mvl-demo]');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const loadDemo = video => {
        if (!video.hasAttribute('src')) video.src = video.dataset.src;
      };
      demos.forEach(video => {
        video.muted = true;
        video.addEventListener('error', () => {
          if (!video.dataset.fallback) return;
          const image = document.createElement('img');
          image.src = video.dataset.fallback;
          image.alt = video.getAttribute('aria-label') || '';
          image.loading = 'lazy';
          image.width = video.width;
          image.height = video.height;
          video.replaceWith(image);
        }, {once: true});
      });
      if ('IntersectionObserver' in window) {
        const demoObserver = new IntersectionObserver(entries => {
          entries.forEach(({target: video, isIntersecting}) => {
            if (isIntersecting) {
              loadDemo(video);
              if (reducedMotion) video.controls = true;
              else video.play().catch(() => { video.controls = true; });
            } else video.pause();
          });
        }, {rootMargin: '0px', threshold: 0.1});
        demos.forEach(video => demoObserver.observe(video));
        document.addEventListener('shopify:section:unload', event => {
          if (event.target.contains(root)) demoObserver.disconnect();
        });
      } else {
        demos.forEach(video => { video.controls = true; loadDemo(video); });
      }
      const slides = root.querySelector('[data-slides]');
      const thumbs = [...root.querySelectorAll('.mvl__thumb')];
      let index = 0;
      const updateNavigation = () => {
        thumbs.forEach((thumb, position) => {
          thumb.classList.toggle('is-active', position === index);
          thumb.setAttribute('aria-pressed', String(position === index));
        });
        const previous = root.querySelector('[data-previous]');
        const next = root.querySelector('[data-next]');
        if (previous) previous.disabled = index === 0;
        if (next) next.disabled = !slides || index >= slides.children.length - 1;
      };
      const go = position => {
        if (!slides?.children[position]) return;
        index = position;
        slides.scrollTo({left: position * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        [...slides.querySelectorAll('video')].forEach(video => video.pause());
        updateNavigation();
      };
      if (slides) {
        thumbs.forEach(thumb => thumb.addEventListener('click', () => go(Number(thumb.dataset.index))));
        root.querySelector('[data-previous]')?.addEventListener('click', () => go(index - 1));
        root.querySelector('[data-next]')?.addEventListener('click', () => go(index + 1));
        slides.addEventListener('scroll', () => {
          index = Math.max(0, Math.min(slides.children.length - 1, Math.round(slides.scrollLeft / (slides.clientWidth || 1))));
          updateNavigation();
        }, {passive: true});
        updateNavigation();
      }
      const json = root.querySelector('[data-mvl-variants]');
      const options = root.querySelector('[data-variants]');
      if (json) {
        const variants = JSON.parse(json.textContent);
        const updateVariant = (notify = true) => {
          const values = options ? [...options.querySelectorAll('.mvl__opt')].map(field => field.querySelector('input:checked')?.value) : null;
          const variant = values ? variants.find(candidate => candidate.options.every((option, i) => option === values[i])) : variants.find(candidate => String(candidate.id) === root.dataset.selectedVariant);
          root.querySelectorAll('[data-vprice]').forEach(price => { price.hidden = !variant || String(price.dataset.vprice) !== String(variant.id); });
          const input = root.querySelector('[data-mvl-variant-id]');
          if (input) input.value = variant ? String(variant.id) : '';
          const stock = root.querySelector('[data-mvl-stock]');
          if (stock) stock.textContent = !variant ? root.dataset.unavailableLabel : variant.available ? root.dataset.inStockLabel : root.dataset.soldOutLabel;
          if (variant) {
            root.dataset.selectedVariant = String(variant.id);
            if (notify) {
              const url = new URL(location.href);
              url.searchParams.set('variant', variant.id);
              history.replaceState({}, '', url);
            }
            const media = variant.featured_media?.id || variant.featured_image?.id;
            const position = slides ? [...slides.children].findIndex(slide => Number(slide.dataset.mediaId) === Number(media)) : -1;
            if (position >= 0 && (notify || !root.hasAttribute('data-branded-first'))) go(position);
          }
          if (notify) {
            input?.dispatchEvent(new Event('change', {bubbles: true}));
            root.dispatchEvent(new CustomEvent('variant:change', {bubbles: true, detail: {variant, sectionId: root.id, productId: root.dataset.productId}}));
            document.dispatchEvent(new CustomEvent('mv:variant', {detail: variant || null}));
          }
        };
        options?.addEventListener('change', () => updateVariant());
        updateVariant(false);
      }
      if ('IntersectionObserver' in window && !window.Shopify?.designMode && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        const observer = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) {entry.target.classList.add('in'); observer.unobserve(entry.target);}
        }), {threshold: 0.05});
        // Content remains visible if an app/editor omits or blocks this script.
        root.querySelectorAll('.mvl-reveal').forEach(element => observer.observe(element));
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
